import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import * as _ from "lodash";
import {
  ITreeOptions,
  TreeComponent,
  TreeModel,
} from "@circlon/angular-tree-component";
import { TreeNode } from "@circlon/angular-tree-component/lib/defs/api";
import { AdminService } from "src/app/pages/admin/admin-service";

@Component({
  selector: "app-area-tree",
  templateUrl: "./area-tree.component.html",
  styleUrls: ["./area-tree.component.scss"],
})
export class AreaTreeComponent implements OnInit {
  @ViewChild("tree") treeComponent: TreeComponent;

  treeNodes = [];
  // treeOptions = {};
  rootOrganisation;
  theNode;
  parentId;
  parentNode;
  loading = false;
  area = "Select Area";

  constructor(private service: AdminService) {}

  @Output()
  getSelectedValue = new EventEmitter();
  @Input() selected: any = {};
  @Input() currentLocation: any = {};
  treeOptions: ITreeOptions = {
    scrollContainer: document.documentElement,
  };

  ngOnInit(): void {
    this.rootOrganisation = "";
    this.getHierarchyNodes();
  }

  getHierarchyNodes() {
    const rootNode = {
      id: this.rootOrganisation ? this.rootOrganisation.id : 1,
      name: this.rootOrganisation
        ? this.rootOrganisation.name +
          " - " +
          this.rootOrganisation.areaType.name
        : "Tanzania",
      children: [],
    };

    this.service.getAdminByParentId(rootNode).subscribe((resp) => {
      rootNode.children =
        resp.data.data && resp.data.data.length > 0
          ? resp.data.data.map((loca) => ({
              ...loca,
              name: loca.name + " - " + loca.areaType,
              type: loca.areaType,
              children: [],
            }))
          : [];
      this.treeNodes = [{ ...rootNode }];

      setTimeout(() => this.treeComponent.treeModel.expandAll(), 200);
      this.parentId = rootNode.id;
    });
  }

  expandChildren($event: any) {
    this.parentNode = $event;
    //console.log('admin area parent node', this.parentNode);
  }

  loadChildren(event: any) {
    //
    const data = event.node.data;
    //
    this.getSelected(data);
    this.loading = true;
    this.service.getAdminByParentId(data).subscribe((response) => {
      //console.log('Response data', response)
      if (response.code === 200) {
        this.loading = false;
      }
      this.theNode = _.filter(this.treeNodes, { children: [] });
      //
      if (this.theNode.length > 0) {
        event.node.data.children =
          response.data.data && response.data.data.length > 0
            ? response.data.data.map((loc) => ({
                ...loc,
                name: loc.name + " - " + loc.areaType,

                children: [],
              }))
            : [];
        this.treeNodes = this.theNode;
      } else {
        this.treeNodes = this.treeNodes;
      }
      setTimeout(() => this.treeComponent.treeModel.expandAll(), 200);
    });
  }

  getSelected(data) {
    this.getSelectedValue.emit(data);
  }

  get currentUser() {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user && user.data && user.data.principal
      ? user.data.principal
      : null;
  }

  get newAdminArea() {
    return this.currentLocation &&
      this.currentLocation.id &&
      this.selected &&
      JSON.parse(this.selected.id) &&
      JSON.parse(this.selected.id) === this.currentLocation.id
      ? false
      : true;
  }

  filterLocations(value: string, treeModel: TreeModel) {
    treeModel.filterNodes((node: TreeNode) =>
      this.searchLocations(value, node.data.name)
    );
  }

  searchLocations(needle: string, haystack: string) {
    const haystackLC = haystack.toLowerCase();
    const needleLC = needle.toLowerCase();

    const hlen = haystack.length;
    const nlen = needleLC.length;

    if (nlen > hlen) {
      return false;
    }
    if (nlen === hlen) {
      return needleLC === haystackLC;
    }
    outer: for (let i = 0, j = 0; i < nlen; i++) {
      const nch = needleLC.charCodeAt(i);

      while (j < hlen) {
        if (haystackLC.charCodeAt(j++) === nch) {
          continue outer;
        }
      }
      return false;
    }
    return true;
  }
}
